module.exports = __webpack_public_path__ + "assets/img/57a50564bac2142d66e8f2dd79850731.png";